import type { TTooltipDefinition } from "./types";

export const TOOLTIPS: Record<TTooltipDefinition["id"], TTooltipDefinition> = {
  "sidebar-new-chat-v1": {
    id: "sidebar-new-chat-v1",
    requiredStage: ["onboarding_complete", "activated"],
    trigger: "firstInteraction",
    title: "New chat",
    content: "Start a conversation with Fundy to get AI guidance for this section.",
  },
  "onboarding-optional-question-v1": {
    id: "onboarding-optional-question-v1",
    requiredStage: ["onboarding_in_progress"],
    trigger: "firstVisit",
    title: "Optional questions",
    content: "Some questions are optional. You can skip them and still complete onboarding.",
  },
  "dashboard-readiness-v1": {
    id: "dashboard-readiness-v1",
    requiredStage: ["activated"],
    trigger: "firstVisit",
    title: "Investor readiness",
    content: "This dashboard highlights gaps and strengths in your fundraising profile.",
  },
};

export const TOOLTIP_LIST = Object.values(TOOLTIPS);
